import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { Button } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import CONSTANTS from "core/constants";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import PatientItem from "../patientItem";
import { SharedProps } from "./types";
import { useMedicoreEnabled } from "./useMedicoreEnabled";
import { getMedicorePatientLink } from "./getMedicorePatientLink";
import { useMindlerApi } from "api/apiv2";

export const MedicoreId = ({ patientUserId }: SharedProps) => {
  const { t } = useTranslation();
  const mindlerApi = useMindlerApi();
  const enabled = useMedicoreEnabled(patientUserId);
  const { data } = useQuery(
    mindlerApi.medicore.getMedicorePatientByPatientUserId.queryOptions(
      {
        patientUserId: Number(patientUserId),
      },
      {
        enabled,
      },
    ),
  );

  const medicorePatientLink = getMedicorePatientLink(data?.medicorePatientId);

  if (!enabled) {
    return null;
  }

  const patientCode = data?.medicorePatientCode ?? CONSTANTS.NO_VALUE;

  return (
    <PatientItem title={t("MEDICORE.MEDICORE_ID")}>
      {patientCode === CONSTANTS.NO_VALUE ? (
        <Typography variant="body">{patientCode}</Typography>
      ) : (
        <StyledButton
          href={medicorePatientLink}
          target="_blank"
          variant="link-button"
        >
          {patientCode}
        </StyledButton>
      )}
    </PatientItem>
  );
};

const StyledButton = styled(Button)`
  font-size: ${(props) => props.theme.FONT.SIZE.BODY};
  padding-top: ${(props) => props.theme.SPACING.SM};
`;
